module.exports = __webpack_public_path__ + "static/media/method-3b-mob.d2f420be.png";